import React, { useContext, useEffect, useState } from "react";
import { Button,  Col, Image, Row } from "react-bootstrap";
import PaquetesIncluidos from "./PaquetesIncluidos";
import AvisoProductoDigital from "./AvisoProductoDigital";


const BodySuscripcion = ({usuarioLogeado = {}}) => {

    console.log(usuarioLogeado)


    return (
        <>
            <Row className="detalle-compra-pricing">
                <PaquetesIncluidos codigoAplicado={false} />

                <Col>
                    <h3>Método de pago:</h3>
        
                    <Row>
                        <Col>
                            <ul>
                                <li>Suscripcion quincenal $99.00MXN</li>
                            </ul>
                        </Col>
                    </Row>
        
                </Col>
            </Row>


            {/* Row para proceder con la renovacion */}

            <Row className="detalle-compra-pricing justify-content-center">
                <Col className="col-10 col-md-8 col-lg-4  p-5">
                    <div style={{backgroundColor: "#00152a", height: "450px", borderRadius: '15px', display: 'flex', flexDirection: 'column', justifyContent: "space-between", color: "#f2f2f2", boxShadow: "0px 0px 50px 10px #f2f2f215"}} className="text-center py-4">
                        <div>
                            <Image src={require("@assets/images/click.png")} width={"250"} alt="Click"/>
                            <p style={{fontSize: "1.5rem"}}>Suscripción quincenal</p>

                            <h2 style={{fontSize: '2.5rem', marginTop: "5px", fontWeight: "bold"}}>$99.00MXN</h2>

                            
                        </div>
                        <div className="p-3">
                            <div className="d-grid gap-2 mb-3">
                                <a href="/procesar-suscripcion" className="mt-4 btn btn-success">Suscribirse</a>
                            </div>
                            <small>La suscripción continúa automáticamente hasta que canceles.</small>
                        </div>
                    </div>
                </Col>
            </Row>



            <Row className="detalle-compra-pricing pb-4 pb-lg-5">
                <AvisoProductoDigital />
            </Row>

        </>
    );
};

export default BodySuscripcion;
